"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchKeywordArchiveContentAggregate = exports.selectArchiveContentByUserSources = exports.selectArchiveContentAggregateById = exports.getArchiveContentAggregateByTopic = exports.searchArchiveContentAggregate = exports.getArchiveContentAggregate = void 0;

var constants_1 = require("../../../constants");

var utils_1 = require("../../../utils");

var axios_api_1 = __importDefault(require("../../axios.api"));

function getArchiveContentAggregate(page, size, sourceId, language) {
  return __awaiter(this, void 0, void 0, function () {
    var lang, url, resultSet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!language) {
            throw new Error("getArchiveContentAggregate: language not set but required!");
          }

          lang = language === "de" ? "1" : "2";
          url = sourceId ? "/api/Content/getBySource/".concat(sourceId, "/").concat(page, "/").concat(size) : "/api/Content/get/".concat(page, "/").concat(size, "/").concat(lang);
          resultSet = [];
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            url: url,
            method: "get",
            headers: {
              "Access-Control-Allow-Origin": true,
              parcel: constants_1.API_PARCEL
            }
          }).then(function (res) {
            resultSet = res.data.payload;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.getArchiveContentAggregate = getArchiveContentAggregate;

function searchArchiveContentAggregate(searchTerm, page, size, language) {
  return __awaiter(this, void 0, void 0, function () {
    var lang, resultSet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!searchTerm || searchTerm.trim().length < 1) {
            throw new Error("searchArchiveContentAggregate: searchTerm not set but required!");
          }

          lang = !language ? "0" : language === "de" ? "1" : "2";
          resultSet = [];
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            method: "get",
            url: "/api/Content/search/".concat(searchTerm, "/").concat(page, "/").concat(size, "/").concat(lang),
            headers: {
              "Access-Control-Allow-Origin": true,
              parcel: constants_1.API_PARCEL
            }
          }).then(function (res) {
            resultSet = res.data.payload;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.searchArchiveContentAggregate = searchArchiveContentAggregate;

function getArchiveContentAggregateByTopic(searchTerm, page, size, language) {
  return __awaiter(this, void 0, void 0, function () {
    var lang, resultSet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!searchTerm || searchTerm.trim().length < 1) {
            throw new Error("getByTopicArchiveContentAggregate: searchTerm not set but required!");
          }

          lang = !language ? "0" : language === "de" ? "1" : "2";
          resultSet = [];
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            method: "get",
            url: "/api/Content/topic/".concat(searchTerm, "/").concat(page, "/").concat(size, "/").concat(lang),
            headers: {
              "Access-Control-Allow-Origin": true,
              parcel: constants_1.API_PARCEL
            }
          }).then(function (res) {
            resultSet = res.data.payload;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.getArchiveContentAggregateByTopic = getArchiveContentAggregateByTopic; // -> obsolete -------------------------------------------------------

function selectArchiveContentAggregateById(contentAgregateId) {
  return __awaiter(this, void 0, void 0, function () {
    var formData, resultSet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!contentAgregateId || contentAgregateId === NaN || contentAgregateId === 0) {
            throw new Error("selectArchiveContentAggregateById: contentAgregateId not set but required!");
          }

          formData = (0, utils_1.getUserInfoFormData)();

          if (contentAgregateId) {
            formData.append("contentAgregateId", contentAgregateId.toString());
          }

          resultSet = null;
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            method: "post",
            url: "/api/###",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(function (res) {
            resultSet = res.data;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.selectArchiveContentAggregateById = selectArchiveContentAggregateById;

function selectArchiveContentByUserSources(sourceId, sourceIds, limit, order, offset) {
  return __awaiter(this, void 0, void 0, function () {
    var formData, resultSet, apiUrl;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          formData = (0, utils_1.getUserInfoFormData)();

          if (sourceId && !sourceIds) {
            formData.append("sourceId", sourceId);
          }

          if (!sourceId && sourceIds) {
            formData.append("sourceIds", sourceIds.toString());
          }

          formData.append("order", order ? order : constants_1.DEFAULT_LIST_ORDER);
          formData.append("offset", offset ? offset.toString() : "0");
          formData.append("limit", limit ? limit.toString() : constants_1.PRIVATE_SELECT_LIMIT.toString());
          resultSet = [];
          apiUrl = sourceIds ? "/api/selectArchiveContentByUserSources" : sourceId ? "/api/selectViewArchiveContentToList" : "";
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(function (res) {
            resultSet = res.data;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.selectArchiveContentByUserSources = selectArchiveContentByUserSources;

function searchKeywordArchiveContentAggregate(searchTerm, language, limit, order) {
  return __awaiter(this, void 0, void 0, function () {
    var lang, formData, resultSet;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!searchTerm || searchTerm.trim().length < 1) {
            throw new Error("searchKeywordArchiveContentAggregate: searchTerm not set but required!");
          }

          lang = !language ? "0" : language === "de" ? "1" : "2";
          formData = (0, utils_1.getUserInfoFormData)();
          formData.append("searchTerm", searchTerm);
          formData.append("language", lang);
          formData.append("order", order ? order : constants_1.DEFAULT_LIST_ORDER);
          formData.append("limit", limit ? limit.toString() : constants_1.PUBLIC_SELECT_LIMIT.toString());
          resultSet = [];
          return [4
          /*yield*/
          , (0, axios_api_1["default"])({
            method: "post",
            url: "/api/searchKeywordViewArchiveContent",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(function (res) {
            resultSet = res.data;
          })];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , resultSet];
      }
    });
  });
}

exports.searchKeywordArchiveContentAggregate = searchKeywordArchiveContentAggregate; // -> obsolete -------------------------------------------------------